import PromotionLibrary from "./PromotionLibrary";

export default PromotionLibrary;